import { render, staticRenderFns } from "./LogUsers.vue?vue&type=template&id=2d3fc1fb&"
import script from "./LogUsers.vue?vue&type=script&lang=js&"
export * from "./LogUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/m1292/Documents/develop/laravel/cure-naruhodoga/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d3fc1fb')) {
      api.createRecord('2d3fc1fb', component.options)
    } else {
      api.reload('2d3fc1fb', component.options)
    }
    module.hot.accept("./LogUsers.vue?vue&type=template&id=2d3fc1fb&", function () {
      api.rerender('2d3fc1fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/designed/admin/LogUsers.vue"
export default component.exports